import useJwt from '@/auth/jwt/useJwt';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchCompanyAll() {
      return new Promise((resolve, reject) => {
        useJwt
          .get('masterData?data=Company')
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },
    fetchCustomerListCompanyAll({ commit }, payload) {
      return new Promise((resolve, reject) => {
        useJwt
          .get('wr1?objectType=CustomerListCompany', { params: payload })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },

    fetchSaleListCompany({ commit }, payload) {
      return new Promise((resolve, reject) => {
        useJwt
          .get('wr1?objectType=SaleListCompany', { params: payload })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },
    
    fetchLocationsAll({ commit }, payload) {
      return new Promise((resolve, reject) => {
        useJwt
          .get('userLocations', { params: payload })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },
    fetchQuotationApprovedAll({ commit }, payload) {
      return new Promise((resolve, reject) => {
        useJwt
          .get('wr1?objectType=MyWR1Quotation', { params: payload })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },
    fetchBookingAll({ commit }, payload) {
      return new Promise((resolve, reject) => {
        useJwt
          .get('wr1?objectType=MyWR1Booking', { params: payload })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },
  },
};
